<template>
  <v-group :config="groupConfig">
    <template v-for="l in layer.layers">
      <m-image v-if="l.type === 'Image'" :layer="l" :key="l.id" />
      <group v-if="l.type === 'Group'" :layer="l" :key="l.id" />
      <print-area v-if="l.type === 'Printarea'" :layer="l" :key="l.id" />
    </template>
  </v-group>
</template>
<script>
import Image from './Image.vue'
import PrintArea from './PrintArea.vue'
export default {
  components: { 'm-image': Image, PrintArea },
  props: {
    layer: {
      type: Object
    },
    mockupID: {
      type: String,
      required: true
    }
  },
  mounted() {},
  computed: {
    groupConfig() {
      return this.layer
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Mockup/Group.vue